import React from 'react'

import { Box, Card, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

interface ReminderNotificationCardProps {
  endsAt: Date | null
}

const ReminderNotificationCard: React.FC<ReminderNotificationCardProps> = ({ endsAt }) => {
  const oneDayEarlier = moment(endsAt).subtract(1, 'day')
  const sevenDaysEarlier = moment(endsAt).subtract(7, 'days')
  const reviewRunsOneDay = moment().isAfter(oneDayEarlier)

  return (
    <Card>
      <Card.Content>
        <Box gap="s16">
          <Text.Header3>
            {i18n.t('performance_process.reviews.reminders.section_title')}
          </Text.Header3>
          {endsAt && !reviewRunsOneDay ? (
            <>
              <Text size="300">
                {i18n.t('performance_process.reviews.reminders.automatic_reminder_to_be_sent')}
              </Text>
              {moment().isSameOrBefore(sevenDaysEarlier) && (
                <Box>
                  <Text size="300">
                    {i18n.t('performance_process.reviews.reminders.seven_days_till_deadline')}
                  </Text>
                  <Text size="300">{sevenDaysEarlier.local().format('LLLL')}</Text>
                </Box>
              )}
              {moment().isSameOrBefore(oneDayEarlier) && (
                <Box>
                  <Text size="300">
                    {i18n.t('performance_process.reviews.reminders.one_day_till_deadline')}
                  </Text>
                  <Text size="300">{oneDayEarlier.local().format('LLLL')}</Text>
                </Box>
              )}
            </>
          ) : (
            <Text size="300">
              {i18n.t(
                'performance_process.reviews.reminders.automatic_reminder_to_be_sent_no_deadline'
              )}
            </Text>
          )}
        </Box>
      </Card.Content>
    </Card>
  )
}

export default ReminderNotificationCard
